import React, { createContext, useContext, useState, useCallback } from "react";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("deli_lang") || "en");

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "en" ? "es" : "en";
      localStorage.setItem("deli_lang", next);
      return next;
    });
  }, []);

  const setLanguage = useCallback((l) => {
    localStorage.setItem("deli_lang", l);
    setLang(l);
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, toggle, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);

// helper to pick bilingual value from settings objects like {en, es} or plain string
export const pick = (val, lang) => {
  if (val == null) return "";
  if (typeof val === "object") return val[lang] ?? val.en ?? "";
  return val;
};
